import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  template: ''
})
export class RedirectComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    const currentUrl = this.router.url;

    const newUrl = currentUrl.replace('inteserra360', 'jsi360');

    this.router.navigateByUrl(newUrl);
  }
}